import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../api';
import { generateQueryString } from '../../../utils/queryKey';
import { OrdersResponse, Order, ISellerOrdersQueryParams, ISellerOrdersResponse } from './interface';

export const orderApi = createApi({
  reducerPath: 'orderApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Orders', 'SellerOrders'],
  endpoints: (builder) => ({
    // Old endpoints - keep for backward compatibility
    getAllOrders: builder.query<OrdersResponse, void>({
      query: () => ({
        url: '/orders/',
        method: 'GET',
      }),
      providesTags: ['Orders'],
    }),

    getOrderById: builder.query<Order, string>({
      query: (orderId) => ({
        url: `/orders/${orderId}`,
        method: 'GET',
      }),
      providesTags: (result, error, orderId) => [{ type: 'Orders', id: orderId }],
    }),

    updateOrderStatus: builder.mutation<Order, { orderId: string; status: string }>({
      query: ({ orderId, status }) => ({
        url: `/orders/${orderId}/status`,
        method: 'PATCH',
        body: { order_status: status },
      }),
      invalidatesTags: (result, error, { orderId }) => [
        { type: 'Orders', id: orderId },
        'Orders',
        'SellerOrders'
      ],
    }),

    // New seller orders endpoint
    getSellerOrders: builder.query<ISellerOrdersResponse, ISellerOrdersQueryParams>({
      query: (params) => ({
        url: `/seller-management/orders?${generateQueryString({ ...params })}`,
        method: 'GET',
      }),
      providesTags: ['SellerOrders'],
    }),
  }),
});

export const {
  useGetAllOrdersQuery,
  useGetOrderByIdQuery,
  useUpdateOrderStatusMutation,
  useGetSellerOrdersQuery,
} = orderApi;